var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.007,
    height: 83.171,
    viewBox: "0 0 86.007 83.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 86.007,
    height: 83.171,
    fill: "#212968"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M187.152,225.022a2.855,2.855,0,0,0-2.028-2.74L161.44,215a6.537,6.537,0,0,0-3.864,0l-23.686,7.281a2.871,2.871,0,0,0,0,5.489l7.71,2.37v10.42c0,4.793,9.008,7.3,17.906,7.3s17.906-2.508,17.906-7.3v-10.42l6.387-1.963v8.748a1.675,1.675,0,1,0,3.351,0v-11.9m-26.7,6.827a3.239,3.239,0,0,1-1.9,0l-14.782-4.544h0l-7.408-2.277,22.2-6.823a3.238,3.238,0,0,1,1.9,0l22.2,6.823Zm-15.5-.678,12.624,3.881a6.537,6.537,0,0,0,3.863,0l12.624-3.881v9.39c0,1.146-5.1,3.95-14.556,3.95s-14.555-2.8-14.555-3.95Z",
    transform: "translate(-101.145 -164.691)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M37.353,78.008H5.994a2.642,2.642,0,1,1,0-5.284H35.275a1.675,1.675,0,1,0,0-3.35H11.754V8.223H30.91a1.655,1.655,0,0,0,.346,0H39.17v20a1.675,1.675,0,0,0,2.882,1.162l3.779-3.923,3.538,3.89a1.7,1.7,0,0,0,1.844.434,1.666,1.666,0,0,0,1.071-1.563v-20h1.943A4.573,4.573,0,0,1,58.8,12.791V45.4a1.675,1.675,0,0,0,3.351,0v-32.6a7.927,7.927,0,0,0-7.918-7.918H52.064A6.568,6.568,0,0,0,45.727,0H35.964a6.567,6.567,0,0,0-6.336,4.873H6.448A6.455,6.455,0,0,0,0,11.32V75.367A6,6,0,0,0,5.994,81.36H37.353a1.675,1.675,0,0,0,0-3.351M42.521,6.551v0c0-.006,0-.011,0-.016a6.566,6.566,0,0,0-.839-3.181h4.046a3.21,3.21,0,0,1,3.206,3.206V23.893l-1.827-2.009a1.685,1.685,0,0,0-1.224-.547,1.654,1.654,0,0,0-1.223.513l-2.139,2.221V6.551M33.241,4.873a3.2,3.2,0,0,1,5.446,0ZM6.448,8.223H8.4V69.374H5.993a5.956,5.956,0,0,0-2.642.615V11.32a3.1,3.1,0,0,1,3.1-3.1",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M110.907,190.5a1.675,1.675,0,0,0,0,3.351h16.971a1.675,1.675,0,0,0,0-3.351Z",
    transform: "translate(-83.786 -146.122)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M117.6,155.856a1.677,1.677,0,0,0-1.675-1.675h-27.4a1.675,1.675,0,1,0,0,3.351h27.4a1.677,1.677,0,0,0,1.675-1.675",
    transform: "translate(-66.619 -118.263)",
    fill: "#212968"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p-2.985f15088d08f3eef3bc238f736b5cc9.svg";
export { ForwardRef as ReactComponent };